// EmailModal.jsx
import React, { useState, useEffect } from "react";
import axiosInstance from "../../axios/axiosInstance";
import "./modal.css";

const EmailModal = ({ onClose, filePath, fileName, submissionRoute }) => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!/\S+@\S+\.\S+/.test(email)) {
      setError("Please enter a valid email address.");
      return;
    }

    // Submit email to 'resume-emails'
    axiosInstance
      .post(`/${submissionRoute}`, { email })
      .then((response) => {
        // Instead of axios.get, directly create a link to the file
        const url = `${filePath}`; // Adjust the URL to your file
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName; // Name of the downloaded file
        document.body.appendChild(a);
        a.click();
        a.remove();
        onClose(); // Close the modal after download
      })
      .catch((error) => {
        console.error("Error:", error);
        setError("Failed to send email. Please try again.");
      });
  };

  // Close modal on Escape key
  const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      onClose();
    }
  };

  // Close modal when clicking outside of it
  const handleClickOutside = (e) => {
    if (e.target.classList.contains("modal")) {
      onClose();
    }
  };

  useEffect(() => {
    // Add event listener for keydown
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      // Cleanup event listener on unmount
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <div className="modal" onClick={handleClickOutside}>
      <div className="modal-content">
        <span className="close" onClick={onClose}>
          &times;
        </span>
        <h2>Enter your email to download the file</h2>
        {error && <p style={{ color: "red" }}>{error}</p>}
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            value={email}
            onChange={handleEmailChange}
            placeholder="Your email"
            required
          />
          <button type="submit">Submit</button>
        </form>
      </div>
    </div>
  );
};

export default EmailModal;
